import { useState, useEffect } from "react";
import axios from 'axios';
import { toast } from "react-toastify";
import { url } from "../../utils/config";
import { btnCancel, btnOne, inputStyleTwo, title } from "../../utils/style";
import { useRecoilState } from "recoil";
import loaderStateAtom from "../../atoms/loaderStateAtom";

function FleetAddCar({ setShowAddCarModal, fleetCustomerID, fleetEstimateCars, appointmentDetails, fetchFleetAppointmentDetails, setOrderState, toggleVIN }) {
    const [carInfo, setCarInfo] = useState([]);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({ car_id: '' });
    const [showLoader, setShowLoader] = useRecoilState(loaderStateAtom);


    function updateFormData(e) {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: '' }));
    }

    const validateForm = () => {
        if (!formData.car_id?.trim()) {
            setErrors({ car_id: 'Please select a car' });
            return false;
        }
        return true;
    };

    async function fetchCarInfo() {
        try {
            setShowLoader(true)
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(url + `/fleet_customer_car/${fleetCustomerID}`, { headers })
            const result = data.data?.filter(car => !fleetEstimateCars.some(existing => existing.id === car.id));
            setCarInfo(result)
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoader(false)
        }
    }

    useEffect(() => {
        fetchCarInfo();
    }, []);


    async function addFleetCar() {
        if (!validateForm()) return;

        try {
            const reqUrl = url + '/fleet_estimate_car'
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const payload = { fleet_user_id: appointmentDetails.fleet_customer.id, booking_id: appointmentDetails.id, car_id: formData.car_id }
            const { data } = await axios.post(reqUrl, payload, { headers });
            fetchFleetAppointmentDetails(appointmentDetails.id)
            setShowAddCarModal(false);
            toast.success(data.message, { autoClose: 3000 })
            setOrderState("")
            toggleVIN(null, false)
        } catch (error) {
            toast.error(error.response?.data?.message || 'Something went wrong', { autoClose: 3000 })
        }
    }

    return (
        <div className="flex justify-center items-center bg-black bg-opacity-60 fixed top-0 left-0 h-screen w-screen p-8 z-50">
            <div className="px-6 py-6 bg-white w-full max-w-md rounded-lg shadow-xl">
                <div className="text-center"><span className={title}>Add Car</span></div>
                <select
                    onChange={updateFormData}
                    className={inputStyleTwo}
                    id="car_id"
                    name="car_id"
                >
                    <option value={""}>--Select--</option>
                    {carInfo.map((car, ind) => <option key={ind} value={car.id}> {car.make} - {car.model} - {car.year} ({car.vin})</option>)}
                </select>
                {errors["car_id"] && (
                    <div className="text-sm text-red-500 mt-1">{errors["car_id"]}</div>
                )}
                <div className="flex justify-between items-center gap-4 mt-2 py-2">
                    <button className={btnCancel} onClick={() => setShowAddCarModal(false)}>Cancel</button>
                    <button onClick={addFleetCar} className={btnOne}>Submit</button>
                </div>
            </div>
        </div>
    );
}

export default FleetAddCar;
